import { Component } from "preact";
import { connect } from "react-redux";
import { clear } from "../../state/actions/waitlistActions";
import Button from "../Button";
import Modal from "../Modal";
import WaitlistForm from "./WaitlistForm";

class Waitlist extends Component {
  constructor() {
    super();
    this.state = {
      showModal: false
    };
  }
  toggleModal = () => {
    const { clear } = this.props;
    const open = !this.state.showModal;
    if (open) {
      clear();
    }
    this.setState({
      showModal: open
    });
  };
  render({ ticket, event, eventDateId }) {
    return (
      <div>
        <Button
          type="secondary"
          aria-label="Join waitlist"
          size="small"
          onClick={this.toggleModal}
        >
          Join waitlist
        </Button>
        <Modal
          showModal={this.state.showModal}
          closeHandler={this.toggleModal}
          title={"Join waitlist"}
          maxWidth={600}
          contents={<WaitlistForm event={event} ticket={ticket} />}
        />
      </div>
    );
  }
}

export default connect(
  (state, ownProps) => ({}),
  { clear }
)(Waitlist);



// WEBPACK FOOTER //
// ./components/waitlist/Waitlist.js